import React, { Component } from "react";
import Col from "../../../../common/grid/Col";
import Row from "../../../../common/grid/Row";
import { connect } from "react-redux";
import { fetchDonors, deleteDonor } from "../../../../actions/donor.js";
import BrowserHistory from "../../../../providers/BrowserHistory.js";
import Button from "../../../../common/button/Button.js";
import SearchInput from "../../../../common/input/SearchInput";
import DonorCard from "../../../../common/donorCard/DonorCard";
import FaPlus from "react-icons/lib/fa/plus";

import "./DonorsIndex.css";

class DonorsIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			confirmed: false,
			donorId: null,
			filterText: ""
		};

		this.onAddNewBoxClick = this.onAddNewBoxClick.bind(this);
		this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
		this.onDeleteClick = this.onDeleteClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	onAddNewBoxClick() {
		BrowserHistory.push("/main/donors/add");
	}

	onDeleteClick(donorId, e) {
		e.stopPropagation();
		this.setState({ showModal: true, donorId });
	}

	onDeleteConfirm() {
		this.setState({ showModal: false, confirm: true });
		this.props.deleteDonor(this.state.donorId);
	}

	onEditClick(donorId, e) {
		e.stopPropagation();
		BrowserHistory.push(`/main/donors/${donorId}/edit`);
	}

	handleChange(filterText) {
		this.setState({ filterText });
	}

	componentDidMount() {
		this.props.fetchDonors();
	}

	render() {
		if (!this.props.donors) {
			return null;
		}

		let donors = this.props.donors.filter(d =>
			d.name.toLowerCase().includes(this.state.filterText.toLowerCase())
		);

		return (
			<div className="donors-index">
				<Row _space-between _no-grow _no-align heading>
					<h2>Manage Donors</h2>
					<Row _gap-16>
						<SearchInput ph="Search donors" onChange={this.handleChange} />
						<Button
							className="btn-green space-between"
							onClick={this.onAddNewBoxClick}
						>
							<FaPlus />
							<span>ADD DONOR</span>
						</Button>
					</Row>
				</Row>
				{/* {this.state.showModal && (
          <Modal
            onConfirm={this.onDeleteConfirm}
            onCancel={() => this.setState({ confirm: false, showModal: false })}
            show={this.state.showModal}
          >
            Are you sure?
          </Modal>
        )}
        <Row _right-16 _wrap section>
          <div className="addNewBox" onClick={this.onAddNewBoxClick}>
            <span className="plus">+</span>
            <h2>Add Donor</h2>
          </div>
        </Row> */}
				<Col>
					{donors.map(d => (
						<DonorCard
							key={d.id}
							donor={d}
							onDelete={this.onDeleteClick}
							onEdit={this.onEditClick}
						/>
					))}
				</Col>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		donors: state.donor.all
	};
};

export default connect(
	mapStateToProps,
	{
		fetchDonors,
		deleteDonor
	}
)(DonorsIndex);



// WEBPACK FOOTER //
// ./src/components/main/donors/index/DonorsIndex.js